import request from '@/utils/request'

export function getPageData() {
  return request({
    url: '/index/voice/index',
    headers: {
      // isToken: false
    },
    method: 'post',
  })
}

export function getAuthorPage(query) {
  return request({
    url: '/index/voice/getAuthorPage',
    headers: {
      // isToken: false
    },
    method: 'post',
    params: query
  })
}

export function getRmdList(query) {
  return request({
    url: '/index/voice/getRmdList',
    headers: {
      // isToken: false
    },
    method: 'post',
	params: query
  })
}



// 新增AI聊天相关API
export function aiChatStream(query) {
  return request({
    url: '/index/chat/stream',
    method: 'post',
    params: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

export function aiChat(query) {
  return request({
    url: '/index/chat/chat',
    method: 'post',
    params: query,
    headers: {
      'Content-Type': 'application/json',
    }
  })
}

export function getChatHistory(query) {
  return request({
    url: '/index/chat/history',
    method: 'get',
    params: query
  })
}